import React from 'react';

import './NavigationButtonCircle.scss';

export const NavigationButtonCircle = () =>
<span
  styleName="navigation-button__back"
>
  <span className="dashicon dashicon-chevron-left" styleName="navigation-button__back-icon" />
</span>;

export default NavigationButtonCircle;
